import React, { createContext, useContext, useEffect, useState } from 'react';
import StatusNotice from './StatusNotice';
import { getCompanyCapabilities } from '../services/api';
const Context = createContext(null);
export const companyFeatureEnabled = (caps, key) => !caps || (caps.features?.[key] ?? (key.startsWith('knowledge.') ? caps.features?.knowledge_base !== false : true));
export const knowledgeTypeEnabled = (caps, kind) => companyFeatureEnabled(caps, 'knowledge_base') && companyFeatureEnabled(caps, 'knowledge.' + kind);
export const useCompanyCapabilities = () => useContext(Context);
const routes = {'/dashboards':'dashboards.read','/knowledge':'knowledge.read','/agent-connections':'agents.configure','/domains':'domains.manage','/reports':'reports.read','/evaluations':'evaluations.run','/subscription':'roles.read'};
export function CompanyCapabilities({ enabled, children }) {
  const [caps,setCaps]=useState(null), [error,setError]=useState('');
  useEffect(() => {
    if (!enabled) return;
    let active=true;
    let pending = false;
    const refresh=() => {
      if (pending) return;
      pending = true;
      return getCompanyCapabilities().then(value=>{if(active){setCaps(value);setError('');}}).catch(e=>{if(active){if ([401,403,404].includes(e.response?.status)) setCaps(null);setError(e.response?.data?.detail?.message || 'Connection interrupted. Retrying access check…');}}).finally(() => { pending = false; });
    };
    refresh(); const timer=setInterval(refresh,5000); window.addEventListener('focus',refresh);
    return ()=>{active=false;clearInterval(timer);window.removeEventListener('focus',refresh);};
  },[enabled]);
  if(enabled && !caps) return <div className="workspace-loading"><p role={error?'alert':'status'}>{error || 'Checking company access…'}</p>{error && <a href="/login">Return to sign in</a>}</div>;
  return <Context.Provider value={caps}><div className="workspace-access-shell">{error && <StatusNotice retrying>{error}</StatusNotice>}<div className="workspace-access-content">{children}</div></div></Context.Provider>;
}
export function canAccessPage(caps, path) {
  const section = {'/dashboards':'dashboards', '/reports':'reports', '/evaluations':'evaluations', '/domains':'domains'}[path];
  if (section && !companyFeatureEnabled(caps, section)) return false;
  if (path === '/dashboards' && (!companyFeatureEnabled(caps, 'tools.dashboarding') || !companyFeatureEnabled(caps, 'dashboards'))) return false;
  const action = routes[path];
  return !caps || !action || (path === '/subscription'
    ? ['roles.read','usage.read','audit.read'].some(permission => caps.permissions.includes(permission))
    : caps.permissions.includes(action));
}
export function CompanyPageAccess({path,children}) {
  const caps=useCompanyCapabilities();
  if(!canAccessPage(caps, path)) return <div className="workspace-loading"><h1>Access unavailable</h1><p>Your company feature settings or role do not allow access to this page.</p><a href="/chat">Return to chat</a></div>;
  return children;
}
